import React from 'react';

import LandingV2 from 'detailsv2/LandingV2';

import { useLandingV2Preview } from '../../shared/hooks';
import { LeftActions } from './LeftActions';
import { RightActions } from './RightActions';
import { IGuestPortalLandingPagesV2Props } from './types';

export const GuestPortalLandingPagesV2 = ({ data, isPrivate }: IGuestPortalLandingPagesV2Props) => {
  const { proposal, config } = useLandingV2Preview({ data });

  return (
    <LandingV2
      data={proposal}
      config={config}
      leftActions={<LeftActions />}
      rightActions={<RightActions />}
      readonly
      isPrivate={isPrivate}
    />
  );
};
